<template>

    <div class="container">

        <app-head title="Banners" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Banners') }}</h1>
            <div class="">
                <inertia-link class="btn btn-primary" :href="route('admin.banners.create')">
                    {{ __('Create') }}
                </inertia-link>
            </div>
        </div>

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" class="" @reset="reset">
                <select-input label="Zone" v-model="form.zone_id">
                    <option :value="null">{{ __('Alle') }}</option>
                    <option :value="zone.id" v-for="zone in zones">{{ zone.name }}</option>
                </select-input>
            </search-filter>
        </div>

        <div class="d-flex justify-content-between">
            <results :meta="banners.meta" />
        </div>

        <div class="card">
            <data-table :items="banners.data"
                        :links="banners.meta.links"
                        :columns="columns"
                        >
                <data-table-row v-for="banner in banners.data" :key="banner.id">
                    <td>
                        {{ banner.id }}
                    </td>
                    <td>
                        <inertia-link class="stretched-link" :href="route('admin.banners.edit', banner)">
                            {{ banner.name }}
                        </inertia-link>
                    </td>
                    <td>
                        {{ banner.description || '-' | truncateWords }}
                    </td>
                    <td>
                        <template v-if="banner.zones.length">
                            <div v-for="zone in banner.zones">
                                {{ zone.name }}
                            </div>
                        </template>
                        <template v-else>
                            {{ '-' }}
                        </template>
                    </td>
                    <td class="text-end">
                        <i class="bi bi-chevron-right"></i>
                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';
    import SearchFilter from '@/shared/Admin/SearchFilter';
    import SelectInput from '@/shared/Inputs/SelectInput';

    import Results from '@/shared/Admin/Results';

    export default {
        props: [
            'filters',
            'zones',
            'banners',
        ],
        components: {
            DataTable,
            DataTableRow,
            SearchFilter,
            SelectInput,
            Results,
        },
        data() {
            return {
                form: {
                    search: this.filters.search,
                    status: this.filters.status,
                    zone_id: this.filters.zone_id,
                },
                columns: {
                    id: {label: 'ID', sortable: 'id'},
                    title: {label: 'Title', sortable: 'title'},
                    description: {label: 'Description'},
                    zones: {label: 'Zones'},
                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.banners.index'), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
        },
    }
</script>